module.exports = __webpack_public_path__ + "img/hr-fluid-wagon-shadow-4.c0bb57b9.png";